<template>
	<div class="scrollable only-y">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-file-account widget-icon accent-text fs-30"></i> {{ $t('menu.log_admin') }}</h2>
		</div>
		<el-card>
			<div slot="header" class="clearfix">
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
						Admin Activity :<br>
						<span style="font-size:32px;">{{ total }}</span>
					</el-card>
				</el-col>
			</div>
			<span>
					<el-input
						class="search-customer mb-10 fl-l" style="width:auto;"
						prefix-icon="el-icon-search"
						placeholder="Search Admin Username"
						clearable
						@keypress.native="doSearchLogAdmin"
						@clear="doSearchLogAdmin"
						@keyup.native="doSearchLogAdmin"
						v-model="searchAdmin">
					</el-input>
				</span>
			<template>
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateAdmin"
						:current-page="currentPage"
						:total="parseInt(total)">
					</el-pagination>
				</el-col>
				<el-table :data="log_admin" class="v2-table.styled" style="width: 100%" v-loading="loadingLogAdmin" element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading">
					<el-table-column prop="nameAdmin" label="Username" width="200" fixed="left">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ capitalizeFirstLetter(props.row.nameAdmin) }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="updatedAt" label="Updated At" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.updatedAt, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="last_login_at" label="Last Login At" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.last_login_at, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column label="Detail Activity" width="" fixed="right">
						<template slot-scope="scope">
							<el-tooltip content="Detail Activity" placement="top">
								<el-button @click="detailLogAdmin(scope.row.adminId)" type="primary" size="small">
									<i class="mdi mdi-eye"></i> 
									<!-- Detail -->
								</el-button>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table>
			</template>
		</el-card>
		<el-card class="mt-10">
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateAdmin"
				:current-page="currentPage"
				:total="parseInt(total)">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')

export default {
	name: 'LogAdmin',
	data () {
		return {
			searchAdmin:this.$route.query.query || "",
			total:'',
			log_admin: [],
			loadingLogAdmin:true,
			currentPage: parseInt(this.$route.query.page) || 1,
			currentPageCustomer: 1,
			formLabelWidth: '200px',
			timeout:null
			// totalCount:100000
		}
	},
	methods: {
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		doSearchLogAdmin(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.loadLogAdmin()
			}, 1000)
		},
		async paginateAdmin(page){
			this.currentPage = page
			await this.loadLogAdmin(this.currentPage)
		},
		async loadLogAdmin(page = 1){
			this.loadingLogAdmin = true
			var self = this
			await api({
				url:config.baseApi+'log_admin?page=' + page + '&query=' + this.searchAdmin,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.log_admin = response.data.data.data
					this.total = response.data.data.total
				}
			}).catch(error => {
				console.log("Error",error)
			})
			this.loadingLogAdmin = false
		},

		// async paginateLogAdmin(page){
		// 	this.currentPage = page
		// 	this.buildQueryParam("page", page)
		// 	await this.loadLogAdmin(this.currentPage)
		// },
		async detailLogAdmin(param){
			this.$router.push('log_admin_detail/' + param)
		}
	},
	async mounted(){
		if(this.$route.query.page){
			this.currentPage = parseInt(this.$route.query.page)
			console.log("current page",this.currentPage);
		}
		await this.loadLogAdmin(this.currentPage)
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';
@import '../assets/scss/tables';
@import '../assets/scss/v2-table';
@import '../assets/scss/vue-good-table';

.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
.search-customer {
  width: 100%;
}
</style>
